import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { ResponsiveImage, baseFromSrc } from "./ResponsiveImage";

export const ServiceCard = ({ service, index = 0 }) => (
  <Reveal delay={(index % 3) * 0.08}>
    <Link
      to="/contact"
      data-testid={`service-card-${service.id}`}
      className="group relative flex h-full flex-col overflow-hidden rounded-2xl border border-white/10 bg-obsidian transition-colors hover:border-amber/40"
    >
      <div className="relative aspect-[4/3] overflow-hidden">
        <ResponsiveImage
          base={baseFromSrc(service.image)}
          alt={service.imageAlt || service.title}
          width={1200}
          height={900}
          sizes="(max-width:640px) 100vw, (max-width:1024px) 50vw, 33vw"
          className={`h-full w-full object-cover ${service.imagePosition || "object-center"} opacity-80 grayscale transition-all duration-700 group-hover:scale-105 group-hover:opacity-100 group-hover:grayscale-0`}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-obsidian via-obsidian/30 to-transparent" />
        <span className="absolute left-4 top-4 font-mono text-xs uppercase tracking-[0.2em] text-amber">
          {service.number}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-6">
        <h3 className="font-display text-xl font-bold tracking-tight text-white">{service.title}</h3>
        <p className="mt-2 flex-1 text-sm leading-relaxed text-white/55">{service.tagline}</p>
        <div className="mt-5 flex items-center justify-between border-t border-white/10 pt-4">
          <span className="font-mono text-[11px] uppercase tracking-widest text-white/40">{service.turnaround}</span>
          <span className="flex items-center gap-1 font-mono text-[11px] uppercase tracking-widest text-amber transition-transform group-hover:translate-x-0.5">
            Get Quote <ArrowUpRight size={14} />
          </span>
        </div>
      </div>
    </Link>
  </Reveal>
);
